<template>
  <div class="container-fluid no-gutters px-0">
    <div class="col-lg-12 mt-3xx mb-2">
      <page-toolbar :title="pageTitle" />

      <div class="alert alert-danger py-2 px-3 small mb-2" v-if="lookupError" role="alert">{{ lookupError }}</div>

      <div class="card">

        <div class="card-body">
          <form @submit.prevent="onSubmitted">
            <div class="row">
              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.first_name.$invalid }"
                >
                  <label for="first_name" class="col-sm-4 col-form-label text-right">
                    First Name
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.first_name.$invalid }"
                      type="text"
                      :disabled="isShow"
                      v-model="model.first_name.$model"
                    />

                    <error-msg :property="model.first_name" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.last_name.$invalid }"
                >
                  <label for="last_name" class="col-sm-4 col-form-label text-right">
                    Last Name
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.last_name.$invalid }"
                      type="text"
                      :disabled="isShow"
                      v-model="model.last_name.$model"
                    />

                    <error-msg :property="model.last_name" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.employee_no.$invalid }"
                >
                  <label for="employee_no" class="col-sm-4 col-form-label text-right">
                    Employee No.
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.employee_no.$invalid }"
                      type="text"
                      :disabled="isShow"
                      v-model="model.employee_no.$model"
                    />

                    <error-msg :property="model.employee_no" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.email.$invalid }"
                >
                  <label for="email" class="col-sm-4 col-form-label text-right">
                    Email
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.email.$invalid }"
                      type="email"
                      :disabled="isShow"
                      v-model="model.email.$model"
                    />

                    <error-msg :property="model.email" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6" v-if="isNew">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.password.$invalid }"
                >
                  <label for="password" class="col-sm-4 col-form-label text-right">
                    Password
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.password.$invalid }"
                      type="password"
                      autocomplete="new-password"
                      v-model="model.password.$model"
                    />

                    <error-msg :property="model.password" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6" v-if="isNew">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.password_confirmation.$invalid }"
                >
                  <label
                    for="password_confirmation"
                    class="col-sm-4 col-form-label text-right"
                  >
                    Password Confirm
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{
                        'form-control-danger': model.password_confirmation.$invalid,
                      }"
                      type="password"
                      autocomplete="new-password"
                      v-model="model.password_confirmation.$model"
                    />

                    <error-msg :property="model.password_confirmation" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.id_no.$invalid }"
                >
                  <label for="id_no" class="col-sm-4 col-form-label text-right">
                    ID No
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.id_no.$invalid }"
                      type="text"
                      :disabled="isShow"
                      v-model="model.id_no.$model"
                    />

                    <error-msg :property="model.id_no" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.date_of_birth.$invalid }"
                >
                  <label for="date_of_birth" class="col-sm-4 col-form-label text-right">
                    Date of Birth
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.date_of_birth.$invalid }"
                      type="date"
                      :disabled="isShow"
                      v-model="model.date_of_birth.$model"
                    />

                    <error-msg :property="model.date_of_birth" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group row">
                  <label for="gender" class="col-sm-4 col-form-label text-right">
                    Gender
                  </label>
                  <div class="col-sm-8">
                    <div class="form-check-inline my-1">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="male"
                          name="gender"
                          :disabled="isShow"
                          v-model="model.gender.$model"
                          value="Male"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="male">Male</label>
                      </div>
                    </div>
                    <div class="form-check-inline my-1">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="female"
                          name="gender"
                          :disabled="isShow"
                          v-model="model.gender.$model"
                          value="Female"
                          class="custom-control-input"
                        />
                        <label class="custom-control-label" for="female">Female</label>
                      </div>
                    </div>
                    <error-msg :property="model.gender" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.phone.$invalid }"
                >
                  <label for="phone" class="col-sm-4 col-form-label text-right">
                    Phone
                  </label>
                  <div class="col-sm-8">
                    <input
                      class="form-control"
                      :class="{ 'form-control-danger': model.phone.$invalid }"
                      type="text"
                      :disabled="isShow"
                      v-model="model.phone.$model"
                    />

                    <error-msg :property="model.phone" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.phone_country.$invalid }"
                >
                  <label for="phone_country" class="col-sm-4 col-form-label text-right">
                    Country
                  </label>
                  <div class="col-sm-8">
                    <select
                      class="form-control"
                      :disabled="isShow"
                      v-model="model.phone_country.$model"
                      v-if="countries.data"
                    >
                      <option value="">Select Country</option>
                      <option
                        v-for="(item, index) in countries.data"
                        :key="index"
                        :value="item.iso2"
                      >
                        {{ item.name }}
                      </option>
                    </select>

                    <error-msg :property="model.phone_country" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.company_id.$invalid }"
                >
                  <label for="company_id" class="col-sm-4 col-form-label text-right">
                    Company Name
                  </label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext" v-if="!isNew">
                      {{ companyName }}
                    </p>
                    <select
                      class="form-control"
                      v-model="model.company_id.$model"
                      v-else-if="companies.data"
                    >
                      <option value="">Select Company</option>
                      <option
                        v-for="(item, index) in companies.data"
                        :key="index"
                        :value="item.company_id"
                      >
                        {{ item.company_name }}
                      </option>
                    </select>
                    <error-msg :property="model.company_id" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.branch_id.$invalid }"
                >
                  <label for="branch_id" class="col-sm-4 col-form-label text-right">
                    Branch
                  </label>
                  <div class="col-sm-8">
                    <select
                      class="form-control"
                      :disabled="isShow"
                      v-model="model.branch_id.$model"
                      v-if="branches.data"
                    >
                      <option value="">Select Branch</option>
                      <option
                        v-for="(item, index) in branches.data"
                        :key="index"
                        :value="item.branch_id"
                      >
                        {{ item.branch_name }}
                      </option>
                    </select>
                    <error-msg :property="model.branch_id" />
                  </div>
                </div>
              </div>

              <div class="col-lg-6" v-if="!isNew">
                <div class="form-group row">
                  <label class="col-sm-4 col-form-label text-right">Status</label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext">
                      {{ model.status_id.$model == 1 ? "Active" : "Inactive" }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-lg-12" v-if="!isNew">
                <div
                  class="form-group row"
                  :class="{ 'has-error': model.comments.$invalid }"
                >
                  <label for="comments" class="col-sm-2 col-form-label text-right">
                    Comments
                  </label>
                  <div class="col-sm-10">
                    <textarea
                      class="form-control"
                      rows="3"
                      :disabled="isShow"
                      v-model="model.comments.$model"
                    ></textarea>
                    <error-msg :property="model.comments" />
                  </div>
                </div>
              </div>

              <div class="col-lg-12">
                <hr class="row" />

                <div class="form-group">
                  <button
                    class="btn btn-primary mr-3"
                    type="submit"
                    :disabled="model.$invalid"
                    :class="{ 'btn-secondary': model.$invalid }"
                    v-if="!isShow"
                  >
                    <slot name="submitButton"></slot>
                  </button>
                  <button
                    class="btn btn-primary mr-3"
                    type="button"
                    @click="onEdit"
                    v-if="isShow"
                  >
                    Edit
                  </button>
                  <button class="btn btn-danger" type="button" @click="onCancelled">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, reactive, ref, watch } from "vue";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  sameAs,
  helpers,
} from "@vuelidate/validators";
import { useStore } from "vuex";

const company_module = "companies";
const branch_module = "branches";
const country_module = "countries";

// a fresh blank form every time the component is created
function blankForm() {
  return {
    employee_id: undefined,
    employee_no: "",
    first_name: "",
    last_name: "",
    password: "",
    password_confirmation: "",
    id_no: "",
    date_of_birth: "",
    gender: "Male",
    email: "",
    phone: "",
    phone_country: "KE",
    status_id: 1,
    company_id: "",
    branch_id: "",
    comments: "",
  };
}

// local copy of a loaded employee, never the store object
function formFromEmployee(employee) {
  return {
    ...blankForm(),
    employee_id: employee.employee_id,
    employee_no: employee.employee_no ?? "",
    first_name: employee.first_name ?? "",
    last_name: employee.last_name ?? "",
    id_no: employee.id_no ?? "",
    date_of_birth: employee.date_of_birth
      ? String(employee.date_of_birth).slice(0, 10)
      : "",
    gender: employee.gender ?? "Male",
    email: employee.email ?? "",
    phone: employee.phone ?? "",
    phone_country: employee.phone_country ?? "KE",
    status_id: employee.status_id,
    company_id: employee.company_id ?? "",
    branch_id: employee.branch_id ?? "",
    comments: employee.comments ?? "",
  };
}

// strictly before 18 years ago; an empty date is left to `required`
function atLeast18(value) {
  if (!value) return true;
  const cutoff = new Date();
  cutoff.setFullYear(cutoff.getFullYear() - 18);
  return new Date(value) < cutoff;
}

export default defineComponent({
  name: "EmployeeDetail",

  props: {
    isEdit: {
      type: Boolean,
      required: true,
      default: false,
    },
    isShow: {
      type: Boolean,
      required: false,
      default: false,
    },
    isNew: {
      type: Boolean,
      required: false,
      default: false,
    },
    // the loaded employee (edit and show only)
    employee: {
      type: Object,
      required: false,
      default: null,
    },
  },

  emits: ["submitForm", "cancelForm", "editForm"],

  setup(props, { emit }) {
    const store = useStore();

    const form = reactive(
      props.employee ? formFromEmployee(props.employee) : blankForm()
    );

    const companies = computed(() => store.getters[`${company_module}/companies`]);
    const branches = computed(() => store.getters[`${branch_module}/branches`]);
    const countries = computed(() => store.getters[`${country_module}/countries`]);

    // a lookup that fails leaves its dropdown empty; say so above the form
    const lookupError = ref("");
    function lookupFailed(what) {
      return () => {
        lookupError.value = `The ${what} could not be loaded. Reload the page to try again.`;
      };
    }

    const pageTitle = computed(() => {
      if (props.isNew) return "New staff member";
      return props.isShow ? "Staff details" : "Edit staff member";
    });

    store.dispatch(`${company_module}/fetchCompanies`, { report: "1" }).catch(lookupFailed("companies"));
    store.dispatch(`${country_module}/fetchCountries`, { report: "1" }).catch(lookupFailed("countries"));

    // branches follow the selected company; on Create a company change clears the branch
    watch(
      () => form.company_id,
      (companyId, previous) => {
        if (props.isNew && previous !== undefined && companyId !== previous) {
          form.branch_id = "";
        }
        if (companyId) {
          store
            .dispatch(`${branch_module}/fetchBranches`, {
              report: "1",
              company_id: companyId,
            })
            .catch(lookupFailed("branches"));
        }
      },
      { immediate: true }
    );

    const companyName = computed(() => {
      if (props.employee?.company?.company_name) {
        return props.employee.company.company_name;
      }
      const match = (companies.value?.data || []).find(
        (c) => c.company_id == form.company_id
      );
      return match ? match.company_name : "";
    });

    const rules = computed(() => ({
      first_name: { required, maxLength: maxLength(50) },
      last_name: { required, maxLength: maxLength(50) },
      employee_no: { maxLength: maxLength(10) },
      email: {
        email,
        requiredWithoutPhone: helpers.withMessage(
          "Email or phone is required",
          requiredIf(() => !form.phone)
        ),
      },
      phone: {
        requiredWithoutEmail: helpers.withMessage(
          "Phone or email is required",
          requiredIf(() => !form.email)
        ),
      },
      phone_country: {
        requiredWithPhone: helpers.withMessage(
          "Country is required with a phone number",
          requiredIf(() => !!form.phone)
        ),
      },
      password: props.isNew ? { required, minLength: minLength(8) } : {},
      password_confirmation: props.isNew
        ? { required, sameAs: sameAs(computed(() => form.password)) }
        : {},
      id_no: { required, maxLength: maxLength(50) },
      date_of_birth: {
        ...(props.isNew ? { required } : {}),
        atLeast18: helpers.withMessage("Must be at least 18 years old", atLeast18),
      },
      gender: { required },
      status_id: {},
      company_id: { required },
      branch_id: props.isNew ? { required } : {},
      comments: { maxLength: maxLength(1000) },
    }));

    const model = useVuelidate(rules, form);

    function onSubmitted() {
      if (props.isNew) {
        emit("submitForm", {
          employee_no: form.employee_no,
          first_name: form.first_name,
          last_name: form.last_name,
          password: form.password,
          password_confirmation: form.password_confirmation,
          id_no: form.id_no,
          date_of_birth: form.date_of_birth,
          gender: form.gender,
          email: form.email,
          phone: form.phone,
          phone_country: form.phone_country,
          company_id: form.company_id,
          branch_id: form.branch_id,
        });
        return;
      }
      // edit: only the fields the API accepts
      emit("submitForm", {
        employee_id: form.employee_id,
        first_name: form.first_name,
        last_name: form.last_name,
        email: form.email,
        phone: form.phone,
        phone_country: form.phone_country,
        gender: form.gender,
        id_no: form.id_no,
        date_of_birth: form.date_of_birth,
        branch_id: form.branch_id,
        employee_no: form.employee_no,
        comments: form.comments,
      });
    }

    function onCancelled() {
      emit("cancelForm");
    }

    function onEdit() {
      emit("editForm");
    }

    return {
      pageTitle,
      lookupError,
      companies,
      branches,
      countries,
      companyName,
      model,
      onSubmitted,
      onCancelled,
      onEdit,
    };
  },
});
</script>
